<template>
  <div class="queue-container" v-loading.fullscreen.lock="display.isLoading">
    <h3>{{ display.title }}</h3>
    <div class="queue-info" v-if="queue._id">
      <div>
        <p><strong>Queue Number 号码</strong></p>
        <h1
          class="gold"
          :class="queue.isFinalised ? 'queue-number-finalised' : ''"
        >
          {{ queue.queueNumber }}
        </h1>
      </div>
      <el-row :gutter="20">
        <el-col :span="12" class="right"
          ><strong>Created 排队日期</strong></el-col
        >
        <el-col :span="12" class="left">{{ queue.createdTimeDisplay }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" class="right"><strong>Status 状态</strong></el-col>
        <el-col :span="12" class="left">{{ queue.statusDisplay }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" class="right"
          ><strong>Waited For 已等待</strong></el-col
        >
        <el-col :span="12" class="left">{{ queue.timeWaitedDisplay }}</el-col>
      </el-row>
    </div>
    <div class="queue-form">
      <el-form ref="queue" :model="queue" :rules="rules.queue">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="firstName">
              <el-input
                class="queue-input"
                v-model="queue.firstName"
                placeholder="First Name 名 (Required 必填)"
                :disabled="!!queue._id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="surname">
              <el-input
                class="queue-input"
                v-model="queue.surname"
                placeholder="Surname 姓 (Required 必填)"
                :disabled="!!queue._id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="phone">
              <el-input
                class="queue-input"
                type="number"
                v-model="queue.phone"
                placeholder="Mobile 手机 (Required 必填)"
                :disabled="!!queue._id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="numberOfCustomers">
              <el-select
                class="queue-input full-width"
                v-model="queue.numberOfCustomers"
                placeholder="Number of Customers 用餐人数 (Required 必选)"
                @change="onChangeNumberOfCustomers"
                :disabled="!!queue._id"
              >
                <el-option
                  v-for="num in numberOfCustomersSelection"
                  :key="num"
                  :label="num === 1 ? '1位 Customer' : `${num}位 Customers`"
                  :value="num"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-button v-if="!queue._id" class="bg-black gold" @click="onClickSubmit">
      Submit 提交
    </el-button>
    <el-button
      v-if="queue._id && !queue.isFinalised"
      class="bg-gold black"
      @click="onClickRefresh"
    >
      Refresh 刷新
    </el-button>
    <el-button
      v-if="queue._id && !queue.isFinalised"
      class="bg-black gold"
      @click="onClickMenu"
    >
      Menu 目录
    </el-button>
    <el-button
      v-if="queue._id && queue.isFinalised"
      class="bg-gold black"
      @click="onClickNewQueue"
    >
      Create New 重新创建
    </el-button>

    <!-- re-create dialog -->
    <el-dialog
      title="Create New 重新创建"
      width="90%"
      :visible.sync="display.dialogs.newQueueConfirm.isVisible"
    >
      <div>
        <p class="centre">
          Are you sure you want to re-queue yourself? This cannot be undone.
        </p>
        <p class="centre">您确定要重新排队吗？此操作不可恢复。</p>
      </div>
      <div slot="footer" class="centre">
        <el-button
          class="bg-gold black"
          @click="display.dialogs.newQueueConfirm.isVisible = false"
          >Cancel 取消</el-button
        >
        <el-button class="bg-black gold" @click="onClickNewQueueConfirm"
          >Confirm 确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import { getMe } from "@/api/customer";
import { getNumberOfCustomerSelections } from "@/utils/dine-in";
import logger from "@/utils/logger";
import { createQueue, getQueueById } from "@/api/dine-in";
import { validateMobilePrefix } from "@/utils";
import { decorateQueue } from "@/utils/dine-in";

const name = "Queue";
const log = logger(name);

export default {
  data() {
    return {
      display: {
        isLoading: true,
        title: "Add to Queue 排队",
        dialogs: {
          newQueueConfirm: {
            isVisible: false,
          },
        },
      },

      customer: {
        phone: "",
        firstName: "",
        surname: "",
      },

      queue: this._initQueue(),
      rules: {
        queue: {
          firstName: [
            {
              required: true,
              trigger: "blur",
              message: "Please enter your first name 请输入名",
            },
          ],
          surname: [
            {
              required: true,
              trigger: "blur",
              message: "Please enter your surname 请输入姓",
            },
          ],
          phone: [
            {
              required: true,
              trigger: "blur",
              message: "Please enter your mobile 请输入手机",
            },
            {
              min: 10,
              max: 10,
              message:
                "Please enter your valid Australian mobile number (10 digits) 请输入有效澳洲号码",
              trigger: "blur",
            },
            { validator: validateMobilePrefix, trigger: "blur" },
          ],
        },
      },

      numberOfCustomersSelection: getNumberOfCustomerSelections(1),
    };
  },
  async created() {
    const queueId = localStorage.getItem("kingdynasty_ec_options_queue_id");
    if (queueId) {
      // get existing queue by ID
      try {
        await this.fetchQueue(queueId);
        if (this.queue.isToday) {
          return;
        }
        localStorage.removeItem("kingdynasty_ec_options_queue_id");
      } finally {
        this.display.isLoading = false;
      }
    }
    if (this.token) {
      this.customer = await getMe();
      this.queue.name = `${this.customer.firstName} ${this.customer.surname}`;
      this.queue.phone = this.customer.phone;
    }
    this.display.isLoading = false;
  },
  computed: {
    ...mapGetters(["customerId", "token"]),
  },
  methods: {
    async fetchQueue(queueId) {
      const queue = await getQueueById(queueId);
      decorateQueue(queue);
      this.queue = queue;
    },

    onChangeNumberOfCustomers(event) {
      this.queue.numberOfCustomers = Number(event);
    },

    onClickSubmit() {
      this.$refs["queue"].validate(async (valid) => {
        if (!valid) {
          log.warn("Queue form invalid");
          return;
        }
        this.display.isLoading = true;
        try {
          const queue = await createQueue(this.queue);
          decorateQueue(queue);
          this.queue = queue;
          localStorage.setItem("kingdynasty_ec_options_queue_id", queue._id);
          this.$message({
            type: "success",
            message: "Successfully queued 排队成功",
          });
        } finally {
          this.display.isLoading = false;
        }
      });
    },

    async onClickRefresh() {
      this.display.isLoading = true;
      try {
        await this.fetchQueue(this.queue._id);
      } finally {
        this.display.isLoading = false;
      }
    },

    onClickMenu() {
      Cookies.set("kingdynasty_ec_home_options_selected_mode", "DINE_IN", {
        expires: new Date(Date.now() + 1000 * 60 * 30),
      });
      this.$router.push("/?hideHomeOptions=true");
    },

    onClickNewQueue() {
      this.display.dialogs.newQueueConfirm.isVisible = true;
    },

    async onClickNewQueueConfirm() {
      this.display.isLoading = true;
      localStorage.removeItem("kingdynasty_ec_options_queue_id");
      this.queue = this._initQueue();
      if (this.token) {
        this.customer = await getMe();
        this.queue.name = `${this.customer.firstName} ${this.customer.surname}`;
        this.queue.phone = this.customer.phone;
      }
      this.display.dialogs.newQueueConfirm.isVisible = false;
      this.display.isLoading = false;
    },

    _initQueue() {
      return {
        name: "",
        phone: "",
        numberOfCustomers: 10,
      };
    },
  },
};
</script>

<style scoped>
.queue-container {
  height: 100vh;
  text-align: center;
  padding: 1rem;
}

.queue-input >>> input,
.queue-input >>> select {
  border: 1px solid #c5b899;
  border-radius: 0;
}

.queue-info {
  margin-bottom: 1.5rem;
}

.queue-number-finalised {
  color: #ccc !important;
  text-decoration: line-through;
}
</style>
